import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPermissionPopupText } from "../../../CommonModals/CommonUtils";
import { setShowLocationPermissionPopup } from "../../../../reducers/common-reducer";
import CenterModal from "../../../UI/Modal/CenterModal";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../../../constants/PublicVariables";
import { goToPlayStore } from "../../../../shared/utility";
import { HELP_ARTICLE } from "../../../../constants/LDConstants";
import { handleEndCallFunc } from "../../../Twilio/Room/roomFunction";

const LocationPermissionPopup = () => {
    const { showLocationPermissionPopup } = useSelector((state) => state.commonReducer);
    const dispatch = useDispatch();

    const locationPermissionText = useMemo(() => {
        return setPermissionPopupText();
    }, []);

    const localisedValues = useLanguageChange();

    const handleDownloadApp = () => {
        handleEndCallFunc();
        goToPlayStore();
        dispatch(setShowLocationPermissionPopup(false));
    };

    const locationHeader = (
        <>
            <h5 className='modal-title'>{localisedValues.location_permission_required_title}</h5>
            <button type='button' className='btn-close' aria-label='Close' onClick={() => dispatch(setShowLocationPermissionPopup(false))}>
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );

    const locationBody = (
        <div className='cms-modal-text'>
            <p>
                {localisedValues.we_cannot_access_your_location}{" "}
                <span id='spanBrowserSetting' dangerouslySetInnerHTML={locationPermissionText}></span>
            </p>
            {PublicVariables.isMobile && (
                <p>
                    {localisedValues.still_facing_issue} {localisedValues.try_the}{" "}
                    <button className='btn default-btn-link' onClick={handleDownloadApp}>
                        {localisedValues.mobile_app}
                    </button>
                </p>
            )}
            {PublicVariables.isMobile && GLOBAL_MEETING_DATA.isAgent && (
                <p>
                    <strong>{localisedValues.note_colon}</strong> <span>{localisedValues.host_features_will_not_be_available_when_using_app}</span>
                </p>
            )}
        </div>
    );
    const locationFooter = (
        <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
            <div className='button'>
                <button className='btn default-btn-link' onClick={() => dispatch(setShowLocationPermissionPopup(false))}>
                    {localisedValues.close}
                </button>
            </div>
            <div className='button'>
                <button className='btn default-btn-primary' onClick={() => window.open(HELP_ARTICLE.RESET_GUIDE_LINK)}>
                    {localisedValues.view_help_article}
                </button>
            </div>
        </div>
    );
    return (
        <CenterModal
            showModal={showLocationPermissionPopup}
            closeModal={() => dispatch(setShowLocationPermissionPopup(false))}
            modalClass='default-modal modal-small mob-bottom-top'
            bodyClassName='default-custom-scroll'
            className='modal-dialog-centered'
            header={locationHeader}
            body={locationBody}
            footer={locationFooter}
            backdrop={"static"}
        />
    );
};

export default LocationPermissionPopup;
